import React from "react";

const ArticleData = ({ selectedArticle }) => {
  if (!selectedArticle || selectedArticle === "") {
    return null;
  }

  return (
    <div className="c-series-data">
      <table className="c-series-data__table">
        <tbody className="two-columns">
          {selectedArticle.formattedDataCollection.map(({ fieldHeader, fieldValue }, index) => (
            <tr className="c-series-data__table-row" key={`${fieldHeader}-${index}`} data-key={`${fieldHeader}-${index}`}>
              <td className="c-series-data__label">{fieldHeader}</td>
              <td className="c-series-data__value">{fieldValue.replaceAll("|", ", ")}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ArticleData;

